/*eslint-disable */
import _ from "lodash";
import { getVessels } from "@/apis/vessels"; // Your raw API file
import { notifyError } from "@/helpers/notification";

// 1. Create a dedicated broadcast channel for vessel synchronization
const vesselChannel = new BroadcastChannel("vessel_cache_sync");

export const vesselStore = {
    namespaced: true, // <--- Crucial for multi-store scaling
    state: {
        // Key-based cache storage for lists
        vesselLists: {},
    },
    mutations: {
        storeVesselList(state, { cacheKey, data }) {
            state.vesselLists[cacheKey] = _.cloneDeep(data);
        },
        invalidateVesselCache(state) {
            state.vesselLists = {};
        },
    },
    actions: {
        // Matches your actual API signature: { filters, matchAny }
        async fetchVesselsWithCache(ctx, { filters = [], matchAny = false } = {}) {
            // 1. Build a deterministic cache key based strictly on the filters
            const cacheKey = `filters_${JSON.stringify(filters)}_matchAny_${matchAny}`;
            console.log(`[Cache Check] Looking for vessels in Vuex state with key: ${cacheKey}`);
            // 2. Return cached data instantly if it exists
            if (ctx.state.vesselLists[cacheKey]) {
                console.log(`[Cache Hit] Serving vessels from Vuex state for key: ${cacheKey}`);
                const data = ctx.state.vesselLists[cacheKey];
                return { data };
            }

            console.log(`[Cache Miss] Fetching from API for key: ${cacheKey}`);
            try {
                // 3. Call your actual API function from src/apis/vessels.js
                const { data } = await getVessels({ filters, matchAny });

                // 4. Save to Vuex cache before returning
                ctx.commit("storeVesselList", { cacheKey, data });
                return { data };
            } catch (err) {
                notifyError(this, err?.response?.data);
                return { data: [] };
            }
        },

        invalidateVessels(ctx) {
            console.log("invalidateVesselCache")
            ctx.commit("invalidateVesselCache");
            vesselChannel.postMessage("INVALIDATE_VESSELS");
        },
    },

}

vesselChannel.onmessage = (event) => {
    if (event.data === "INVALIDATE_VESSELS") {
        console.log("[Cross-Tab Sync] Invalidation signal received from another tab. Clearing local cache...");

        // We import the store instance to commit directly (avoiding an infinite loop of re-broadcasting actions)
        import("./index").then(({ store }) => {
            store.commit("vesselStore/invalidateVesselCache");
        });
    }
};